// extracted by mini-css-extract-plugin
export var box = "certificates-module--box--36323";
export var certificateBadges = "certificates-module--certificate-badges--bd43d";
export var certificatesPane = "certificates-module--certificates-pane--5adf3";
export var description = "certificates-module--description--3e91c";
export var heading = "certificates-module--heading--4a104";
export var image = "certificates-module--image--65c3f";
export var leftBox = "certificates-module--left-box--76bdb";
export var rightBox = "certificates-module--right-box--85ab5";
export var textBox = "certificates-module--text-box--e1b32";